// @core/api/endpoints/userprofile/delete_avatar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/userprofile';

/**
 * Delete avatar
 * Permanently deletes an avatar image and its associated data. If the active avatar is deleted, another avatar may become active.
 */
export async function DeleteAvatar(
  profile_id: string,
  avatar_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/avatars/:avatar_id`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  requestPath = requestPath.replace(':avatar_id', encodeURIComponent(avatar_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
